import { Box, Button, Typography } from '@mui/material';

import { FilterAlt } from '@mui/icons-material';
import ClearIcon from '@mui/icons-material/Clear';
import { useFiltersCard } from './hooks';
import { Select } from 'ui';
import { t } from 'i18next';
import { theme } from '@store';

export const FiltersCard = () => {
  const {
    statusOptions,
    handleToggleFiltersCard,
    handleChangeStatusFilter,
    handleChangeTeamFilter,
    handleChangeRolesFilter,
    handleChangeEntityNameFilter,
    handleChangeEntityTypeFilter,
    handleChangeSupervisorFilter,
    rolesOptions,
    teamTypeOptions,
    entityTypeOptions,
    supervisorOptions,
    dynamicEntityNameOptions,
    filters,
    resetFilters,
    handleApply,
    isResetDisabled,
    isApplyDisabled,
  } = useFiltersCard();

  return (
    <Box
      sx={{
        minWidth: '260px',
        maxWidth: '260px',
        boxShadow: 'initial',
        display: 'flex',
        flexDirection: 'column',
      }}
    >
      <Box
        sx={{
          display: 'flex',
          justifyContent: 'space-between',
          width: '100%',
          padding: '0',
          pt: '1rem',
          pb: '0.5rem',
          mb: '0.5rem',
        }}
      >
        <Box sx={{ display: 'flex', alignItems: 'center', gap: '0.5rem' }}>
          <FilterAlt />
          <Typography variant='subtitle1'>Filters</Typography>
        </Box>
        <Box
          onClick={handleToggleFiltersCard}
          sx={{
            justifyContent: 'center',
            alignItems: 'center',
            display: 'flex',
            ':hover': {
              cursor: 'pointer',
              bgcolor: theme => theme.palette.grey[50],
              borderRadius: '6px',
            },
            height: '30px',
            width: '30px',
          }}
        >
          <ClearIcon />
        </Box>
      </Box>

      <Box
        sx={{
          width: '100%',
          display: 'flex',
          flexDirection: 'column',
          gap: '1rem',
          maxHeight: `calc(100vh - 465px)`,
          overflowY: 'auto',
          [theme.breakpoints.down('md')]: {
            maxHeight: 'calc(100vh - 310px)',
          },
          pt: 1,
        }}
      >
        <Select
          name='account_status'
          size='medium'
          label='Account Status'
          onChange={handleChangeStatusFilter}
          value={filters.status}
          options={statusOptions}
          clearLabel='All'
          clearable
          sx={{
            backgroundColor: theme => theme.palette.common.white,
          }}
        />

        <Select
          name='role'
          size='medium'
          label='Role'
          onChange={handleChangeRolesFilter}
          value={filters.role}
          options={rolesOptions}
          clearLabel='All'
          clearable
          sx={{
            backgroundColor: theme => theme.palette.common.white,
          }}
        />

        <Select
          name='supervisor_id'
          size='medium'
          label='Supervisor'
          onChange={handleChangeSupervisorFilter}
          value={filters.supervisor_id}
          options={supervisorOptions}
          clearLabel='All'
          clearable
          sx={{
            backgroundColor: theme => theme.palette.common.white,
          }}
        />

        <Select
          name='team_id'
          size='medium'
          label='Team'
          onChange={handleChangeTeamFilter}
          value={filters.team_id}
          options={teamTypeOptions}
          clearLabel='All'
          clearable
          sx={{
            backgroundColor: theme => theme.palette.common.white,
          }}
        />

        <Select
          name='assigned_entity_type'
          size='medium'
          label='Assigned entity type'
          onChange={handleChangeEntityTypeFilter}
          value={filters.assigned_entity_type}
          options={entityTypeOptions}
          clearLabel='All'
          clearable
          sx={{
            backgroundColor: theme => theme.palette.common.white,
          }}
        />

        <Select
          name='assigned_entity_name'
          size='medium'
          label='Assigned entity name'
          onChange={handleChangeEntityNameFilter}
          value={filters.assigned_entity_id}
          options={dynamicEntityNameOptions}
          clearLabel='All'
          clearable
          sx={{
            backgroundColor: theme => theme.palette.common.white,
          }}
        />
      </Box>

      <Box
        sx={{
          display: 'flex',
          gap: '0.5rem',
          width: '100%',
          py: '1rem',
        }}
      >
        <Button
          variant='outlined'
          onClick={resetFilters}
          sx={{ width: '100%', maxHeight: '2rem' }}
          disabled={isResetDisabled}
        >
          {t('general.reset')}
        </Button>
        <Button
          onClick={handleApply}
          variant='contained'
          color='secondary'
          loadingPosition='center'
          sx={{
            color: 'white',
            width: '100%',
            maxHeight: '2rem',
          }}
          disabled={isApplyDisabled}
        >
          {t('general.apply')}
        </Button>
      </Box>
    </Box>
  );
};
